<template>
  <svg
    width="44"
    height="36"
    viewBox="0 0 44 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.58551 3.6858C2.52094 4.74987 1.67644 6.01327 1.10027 7.40381C0.524096 8.79435 0.227539 10.2848 0.227539 11.79C0.227539 13.2951 0.524096 14.7856 1.10027 16.1761C1.67644 17.5667 2.52094 18.8301 3.58551 19.8941L17.5813 33.8879C18.7534 35.0596 20.3428 35.7178 22.0001 35.7178C23.6574 35.7178 25.2468 35.0596 26.4188 33.8879L40.4147 19.892C41.4904 18.8307 42.3455 17.567 42.9308 16.1737C43.5161 14.7805 43.8201 13.2852 43.8251 11.7741C43.8302 10.2629 43.5363 8.76563 42.9603 7.3685C42.3844 5.97138 41.5377 4.70198 40.4691 3.63341C39.4006 2.56484 38.1312 1.7182 36.7341 1.14223C35.3369 0.56626 33.8397 0.272345 32.3285 0.277408C30.8173 0.282471 29.3221 0.58641 27.9288 1.17173C26.5356 1.75704 25.2719 2.61217 24.2105 3.68788L23.9147 3.98163L28.8522 8.91913C29.0963 9.17521 29.2305 9.51667 29.2261 9.87045C29.2217 10.2242 29.079 10.5622 28.8286 10.8121C28.5781 11.062 28.2398 11.204 27.886 11.2077C27.5322 11.2113 27.1911 11.0763 26.9355 10.8316L19.7897 3.6858C17.6408 1.53706 14.7264 0.329912 11.6876 0.329912C8.64874 0.329912 5.73435 1.53706 3.58551 3.6858Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ProductMenuIcon3',
} as DefineComponent
</script>
